export const ease = [0.22, 1, 0.36, 1];

export const CONTACT_EMAIL = "office@biosmartsolutions.co.nz";

export const NAV = [
  { label: "Products", to: "/products" },
  { label: "Consulting", to: "/consulting" },
  { label: "Insights", to: "/insights" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const STATUS = {
  available: { label: "Available", cls: "bg-sage-light text-teal-ink border-sage", dot: "bg-teal" },
  in_development: { label: "In development", cls: "bg-mist text-teal-ink border-stone", dot: "bg-moss animate-pulse" },
  coming_soon: { label: "Coming soon", cls: "bg-paper text-teal border-teal/40 border-dashed", dot: "border border-teal bg-transparent" },
};

export const PRODUCT_CATEGORIES = ["Biological control", "Biopesticides", "Functional biodiversity", "Sourcing & supply"];
export const ARTICLE_CATEGORIES = ["Innovation", "Extension"];
export const AUDIENCES = ["Growers", "Agronomists", "Advisors", "Product reps", "Industry"];

export const DISCIPLINES = [
  "Integrated Pest Management",
  "Biological Control",
  "Functional Biodiversity",
  "Applied R&D",
  "Field Experimentation",
  "Knowledge Transfer",
  "Pacific Island Markets",
];

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-NZ", { day: "numeric", month: "short", year: "numeric" });
};

export const pad = (n) => String(n).padStart(2, "0");
